export default __webpack_public_path__ + "static/timberline-aviation-small-c808447f657749c044674f23abc81467.jpg";